import React from 'react';
import { Modal, Button, Form } from 'antd';
import { ReactComponent as CrossSvg } from '@assets/icons/cross.svg';

interface ConfirmModalProps {
  visible: boolean;
  title: string;
  description: string;
  okText?: string;
  width?: number;
  onCancel: () => void;
  onConfirm: () => void;
}

function ConfirmModal({
  visible,
  title,
  description,
  okText,
  width = 500,
  onCancel,
  onConfirm
}: ConfirmModalProps) {
  return (
    <Modal
      open={visible}
      footer={null}
      destroyOnClose
      centered={true}
      closeIcon={<CrossSvg />}
      width={width}
      onCancel={onCancel}
    >
      <div className="modal_container">
        <h2
          className="modal_container__title"
          style={{ fontSize: 22, marginBottom: '0.5em' }}
        >
          {title}
        </h2>
        <p className="modal_container__subtitle">{description}</p>
        <Form layout="vertical" onFinish={onConfirm}>
          <div className="modal_container__actions">
            <Button
              type="link"
              size="large"
              htmlType="button"
              onClick={onCancel}
              style={{
                marginRight: '20px',
                border: 'none',
                height: 48,
                padding: '8px 15px'
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              style={{ width: 216, height: 48, padding: '8px 15px' }}
            >
              {okText || title}
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}

export default ConfirmModal;
